import { FirebaseOptions, getApp, getApps, initializeApp } from 'firebase/app'
import { Messaging, getMessaging, isSupported } from 'firebase/messaging'

export const firebaseConfig: FirebaseOptions = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
}

/** Falta config do Firebase (.env) → push fica desligado, sem quebrar o app. */
export const isFirebaseConfigured = Boolean(firebaseConfig.apiKey && firebaseConfig.projectId)

let messagingPromise: Promise<Messaging | undefined> | undefined

/**
 * Instância do Firebase Messaging, criada uma única vez.
 * Retorna `undefined` quando o Firebase não está configurado ou o navegador não suporta.
 */
export const getFirebaseMessaging = (): Promise<Messaging | undefined> => {
  if (!messagingPromise) {
    messagingPromise = (async () => {
      if (!isFirebaseConfigured) return undefined

      const supported = await isSupported().catch(() => false)
      if (!supported) return undefined

      const app = getApps().length ? getApp() : initializeApp(firebaseConfig)
      return getMessaging(app)
    })()
  }

  return messagingPromise
}
